import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=d877bde8"
import script from "./Journals.vue?vue&type=script&lang=ts"
export * from "./Journals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d877bde8')) {
      api.createRecord('d877bde8', component.options)
    } else {
      api.reload('d877bde8', component.options)
    }
    module.hot.accept("./Journals.vue?vue&type=template&id=d877bde8", function () {
      api.rerender('d877bde8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Journals.vue"
export default component.exports